<template>
  <header class="page-header">
    <div class="page-header__lead">
      <button v-if="back"
              type="button"
              class="page-header__back"
              aria-label="Back"
              @click="$emit('back')">
        <svg width="11" height="20" viewBox="0 0 12 20" fill="none">
          <path d="M10 2L2 10L10 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
      <h1 class="page-header__title">{{ title }}</h1>
      <slot name="badge" />
    </div>
    <slot name="trailing" />
  </header>
</template>

<script>
// Shared frosted, sticky page header — one consistent treatment across the
// secondary tabs (Tip, Bill, Review). Title on the left (with an optional badge),
// optional trailing slot on the right (e.g. a venue logo). Place it OUTSIDE
// VContainer so it spans edge to edge.
export default {
  name: "VPageHeader",
  props: {
    title: { type: String, required: true },
    back: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.page-header {
  position: sticky;
  top: 0;
  z-index: 1100;

  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  padding: calc(20px + var(--safe-top, 0px)) 20px 14px;

  background: var(--header-blur-bg);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border-bottom: 1px solid var(--border-subtle);
  box-shadow: inset 0 1px 0 var(--header-hairline);
}

.page-header__lead {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  min-width: 0;
}

.page-header__back {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  margin-left: -6px;

  border: none;
  background: transparent;
  color: var(--text-primary);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: transform var(--dur-fast) var(--ease-standard);

  &:active { transform: scale(0.9); }
}

.page-header__title {
  margin: 0;
  font-size: 27px;
  font-weight: var(--weight-black);
  letter-spacing: -0.02em;
  line-height: 1.1;
  color: var(--text-primary);
}
</style>
